import { Button, Stack } from '@mui/material'
import { INumericReleaseItem } from '@planning/rt-stores/numericRelease/NumericReleaseItem'
import { useTranslate } from '@tolgee/react'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { ReleaseDetailsViewStore } from '../../../Stores/ReleaseDetailsViewStore'
import { ReleaseDetailsHeader } from '../../molecules/ReleaseDetailsHeader'
import { NumericReleaseDetailsOptions } from './NumericReleaseDetailsOptions'

type Props = {
  viewStore: ReleaseDetailsViewStore
  numericRelease: INumericReleaseItem
}

export const NumericReleaseDetailsHeader: FC<Props> = observer(({ numericRelease, viewStore }) => {
  const { t } = useTranslate()

  const { shippingLineName, referenceNumber } = numericRelease.data

  const identifier = shippingLineName ? `${shippingLineName}-${referenceNumber}` : referenceNumber

  const breadCrumbs = [
    {
      label: t(PATHS.orders.numericReleases.title, 'Numeric releases'),
      route: PATHS.orders.numericReleases.url,
    },
    {
      label: `${identifier}`,
    },
  ]

  const title = t('numericReleaseDetails', 'Numeric release details')

  return (
    <ReleaseDetailsHeader
      title={title}
      breadCrumbs={breadCrumbs}
      rightRenderOption={
        <Stack direction='row' spacing={2} alignItems='center'>
          <Button
            disabled={numericRelease.isExpired}
            data-cy='assign-container-header-button'
            variant='contained'
            sx={{ whiteSpace: 'nowrap' }}
            onClick={() => viewStore.setIsAssignDialogOpen(true)}
          >
            {t('assignContainer', 'Assign container')}
          </Button>
          <NumericReleaseDetailsOptions numericRelease={numericRelease} viewStore={viewStore} />
        </Stack>
      }
    />
  )
})
